<template>
  <section class="businesses">
    <main class="main" :class="{ 'expand-main': isMenuCollapse }">
      <div class="col-12" v-if="!add">
        <Step3 :simplify="true" :targetId="$route.params.id" />
      </div>
      <div class="row justify-content-center" v-if="add">

        <!-- Top component to display the step by step process -->
        <div class="col-2 d-flex justify-content-center">
          <RoundedBox/>
        </div>
        <div class="col-8 d-flex justify-content-center">
          <Stepper
            v-if="onBoarding.substep > 0 || !onBoarding.startProcess"
            :step="onBoarding.step"
            />
        </div>
        <div class="col-2"></div>
        <div class="col-11">
          <MultiStep :addOrder="true"/>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
import Step3 from "@/components/Onboarding/MultiSteps/Step3.vue";
import MultiStep from "@/components/Onboarding/MultiStep.vue";
import Stepper from "@/components/Onboarding/Stepper.vue";
import { mapState,mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import TimeEvents from "@/components/Common/TimeEvents.vue";
import Tabs from "@/components/Common/Tabs.vue";
import { targetsService } from "@/_services";
import RoundedBox from "../components/Onboarding/RoundedBox.vue";



export default {
  data() {
    return {
      add:false,
      loadingHistory: true,
      historyItems: [],
      mainTabSelected: 1,
      targetId: 0,
      mainTabs: {
        1: {
          id: 1,
          name: this.$t('lang.label.order'),
        },
        2: {
          id: 2,
          name: this.$t('lang.label.history'),
        },
      },
    };
  },
  methods: {
    ...mapActions("onboarding", {
      setTypeForm:"setTypeForm",
    }),
    changeMainTab(itemSelected){
      this.mainTabSelected = itemSelected

      //If the tab selected is "History"
      if(itemSelected == 2) this.getOrderHistory()
    },
    getOrderHistory(){
      this.loadingHistory = true
      let data = {
          client_id: this.client_id,
          history: true,
          targetId: this.targetId
        };
        targetsService.getTargetListByClientAndStatus(data).then((response) => {

          if (response !== undefined) {
            this.loadingHistory = false;
            this.historyItems = response.historyEvents;
          }
        });
    },
  },
  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      onBoarding: (state) => state.onboarding,
      user: state => state.authentication.user
    }),
  },

  created() {
    if(this.$route.params.id == "add"){
      this.add = true;
      this.setTypeForm("add")
    } else {
      this.targetId = this.$route.params.id
    }
  },
  components: {
    Step3,
    MultiStep,
    LoadingSpinner,
    Tabs,
    TimeEvents,
    Stepper,
    RoundedBox
  },
};
</script>
